import { useTranslation } from '@/lib/i18n';
import { StatusBadge } from '@/components/ui';
import { partnerStatusOf } from '../lib/partnerFormat';
import type { OpenApiPartner } from '../types/openApiPartner';

const VARIANT = { CALLABLE: 'success', STOPPED: 'neutral', OUT_OF_PERIOD: 'warning', NO_IP: 'warning' } as const;
const LABEL = { CALLABLE: '호출 가능', STOPPED: '사용 중지', OUT_OF_PERIOD: '기간 외', NO_IP: 'IP 미등록' } as const;

/** callable 기준 상태 — 호출 가능 / 사용 중지 / 기간 외 / IP 미등록. */
export const PartnerStatusBadge = ({ partner }: { partner: OpenApiPartner }) => {
  const { t } = useTranslation('common');
  const status = partnerStatusOf(partner);
  return <StatusBadge variant={VARIANT[status]} label={t(`openApiPartners.status.${status}`, LABEL[status])} />;
};
